'use client';

import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:localcoin": true
    });
  } catch (e) {}
}();
import React, { useState } from 'react';
import useSWR from 'swr';
import AlertBar from '@/components/atoms/AlertBar';
import { useAnnouncement } from '@/contexts/AnnouncementContext/hooks';
import { useLang } from '@/hooks/useLang';
import { AlertDocument } from '@/prismicio-types';
import { ALERT_REFETCH_INTERVAL } from './consts';
import { getAlert } from './utils';
const AlertsAndAnnouncements = () => {
  const $ = _c(13);
  const [showAlert, setShowAlert] = useState(true);
  const lang = useLang();
  const {
    announcement,
    dismiss
  } = useAnnouncement();
  let t0;
  let t1;
  if ($[0] !== lang) {
    t0 = ["alert", lang];
    t1 = () => getAlert(lang);
    $[0] = lang;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      refreshInterval: ALERT_REFETCH_INTERVAL
    };
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const {
    data: alert
  } = useSWR(t0, t1, t2);
  let t3;
  if ($[4] !== alert || $[5] !== showAlert) {
    t3 = showAlert && alert && <div className="animate-fade-in"><AlertBar variant="alert" content={alert.content} onClose={() => setShowAlert(false)} /></div>;
    $[4] = alert;
    $[5] = showAlert;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== announcement || $[8] !== dismiss) {
    t4 = announcement && <AlertBar variant="announcement" content={announcement.content} onClose={dismiss} />;
    $[7] = announcement;
    $[8] = dismiss;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t3 || $[11] !== t4) {
    t5 = <div data-sentry-component="AlertsAndAnnouncements" data-sentry-source-file="index.tsx">{t3}{t4}</div>;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
};
export default AlertsAndAnnouncements;